import React from 'react';
import { IoMdClose } from 'react-icons/io';
import { FaChevronDown, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './style.scss';

//POSITIONS -> start center start

const MobileSelectModal = ({
  selected,
  children,
  show,
  setShow,
  position = 'end',
  labelStyles = {},
  iconSize = 14,
  withMaxWidth = false,
}) => {
  const getMaxWidthStyles = () => {
    return withMaxWidth
      ? {
          maxWidth: '88px',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
        }
      : {};
  };

  return (
    <>
      <div className={`mobile-select ${position}`}>
        <div
          className="mobile-select__sel"
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            setShow(true);
          }}
        >
          <span style={{ ...labelStyles, ...getMaxWidthStyles() }}>{selected}</span>
          <FaChevronDown size={iconSize} />
        </div>
      </div>
      {show && (
        <div className="mobile-select-modal">
          <IoMdClose
            onClick={() => setShow(false)}
            className="mobile-select-modal__close"
            color="#FFF"
            size={28}
          />
          <div className="mobile-select-modal__list">{children}</div>
        </div>
      )}
    </>
  );
};

export default MobileSelectModal;
